export default __webpack_public_path__ + "static/media/group2.006b9348.jpg";